import { z } from "zod";
import { emailSchema, passwordSchema } from "./common.schema.ts";

export const createUserSchema = z.object({
  email: emailSchema,
  password: passwordSchema,
  confirmPassword: z.string().min(1, "Veuillez confirmer le mot de passe"),
});
export const updateUserPasswordSchema = z.object({
  password: passwordSchema,
  confirmPassword: z.string().min(1, "Veuillez confirmer le mot de passe"),
});
